import { render } from "./RequiSalarial.vue?vue&type=template&id=7dcdd2c4&scoped=true"
import script from "./RequiSalarial.vue?vue&type=script&lang=js"
export * from "./RequiSalarial.vue?vue&type=script&lang=js"

import "./RequiSalarial.vue?vue&type=style&index=0&id=7dcdd2c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7dcdd2c4"

export default script